class CompleteTheLook {

  constructor() {

    this.modal = document.getElementById('CompleteTheLookModal');
  
    if (!this.modal) return;

    this.productId = this.modal.dataset.productId;
    this.mainVariantId = Number(this.modal.dataset.mainVariantId);
    this.sectionId = this.modal.dataset.sectionId;
    this.recommendationsUrl = this.modal.dataset.recommendationsUrl;
    this.discountNote = this.modal.dataset.discountNote
    this.currency = this.modal.dataset.currency;
    this.discountTiers = {
      1: Number(this.modal.dataset.tierOneDiscount),
      2: Number(this.modal.dataset.tierTwoDiscount),
      3: Number(this.modal.dataset.tierThreeDiscount)
    };
    this.tierMessages = {
      1: this.modal.dataset.tierOneMessage,
      2: this.modal.dataset.tierTwoMessage,
      3: this.modal.dataset.tierThreeMessage
    };

    this.eligibleAccessoryCount = Number(this.modal.dataset.eligibleAccessoryCount);
    this.hasMainProduct = false;
    this.currentDiscount = this.getDiscountTier(this.eligibleAccessoryCount, this.hasMainProduct);

    this.productsLoaded = false;
    this.productsContainer = this.modal.querySelector(
      '.complete-the-look-modal__products'
    );

    this.contentContainer = this.modal.querySelector(
      '.complete-the-look-modal__content'
    );

    this.modalHeader = this.modal.querySelector(
      '.complete-the-look-modal__header'
    );

    this.modalActions = this.modal.querySelector(
      '.complete-the-look-modal__actions'
    );

    this.trigger = document.querySelector('.complete-the-look-trigger');
    this.defaultAtc = document.querySelector('[data-add-to-cart]');

    this.closeButton = this.modal.querySelector('.complete-the-look-modal__close');
    this.viewCartButton = this.modal.querySelector(
        '.complete-the-look-modal__cart'
    );

    this.overlay = this.modal.querySelector('.complete-the-look-modal__overlay');
    this.useColorSwatches = this.modal.dataset.colorSwatches === 'true';

    // Progress bar
    this.progress = this.modal.querySelector(
      '.complete-the-look-modal__progress'
    );

    this.progressFill = this.modal.querySelector(
      '.complete-the-look-modal__progress-fill'
    );

    this.progressText = this.modal.querySelector(
      '.complete-the-look-modal__progress-text'
    );

    this.events();
    this.checkComplementaryProducts();

  }

  events() {

    this.trigger?.addEventListener('click', async (event) => {
      event.preventDefault();
      event.stopPropagation();

      await this.addMainProduct();

      this.open();
    });

    this.defaultAtc?.addEventListener('click', (event) => {
      if (!this.trigger || this.trigger.offsetParent === null) return;
      this.open();
    });

    this.closeButton?.addEventListener('click', () => this.close());

    this.overlay?.addEventListener('click', () => this.close());

    document.addEventListener('keydown', (e) => {

      if (e.key === 'Escape') {

        this.close();

      }

    });

    this.viewCartButton?.addEventListener('click', () => {
        const cartButton = document.querySelector(
            '.js-drawer-open-cart[aria-expanded="false"]'
        );
        this.close();
        if (cartButton) {
            cartButton.click();
        }
    });

    document.addEventListener('rebuy:cart.change', async () => {
      await this.refreshBundleState();

      this.updateProgress();
      this.updateProductPricing();
      this.updateAddedButtons();
    });

    window.addEventListener('resize', () => {
      this.updateProductsOverflow();
    });
  }

  async open() {
    await this.refreshBundleState();
    this.updateProgress();
    this.updateProductPricing();

    this.modal.hidden = false;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.modal.classList.add('is-open');
      });
    });

    document.documentElement.classList.add('complete-the-look-open');
    document.documentElement.classList.add('lock-scroll');

    if (!this.productsLoaded) {
      await this.loadProducts();
      this.productsLoaded = true;
      this.updateAddedButtons();
    }
  }

  close() {
    this.modal.classList.remove('is-open');

    document.documentElement.classList.remove('complete-the-look-open');
    document.documentElement.classList.remove('lock-scroll');

    setTimeout(() => {
      this.modal.hidden = true;
    }, 300);
  }

  updateProgress() {
    const count = this.eligibleAccessoryCount;
    const discount = this.currentDiscount;
    const progressCount = this.hasMainProduct
    ? Math.min(count + 1, 3)
    : 0;

    const markers = this.modal.querySelectorAll(
      '.complete-the-look-modal__progress-marker'
    );

    markers.forEach((marker, index) => {
      const tier = index + 1;
      const marked = progressCount >= tier;

      marker.classList.toggle(
        'complete-the-look-modal__progress-marker--marked',
        marked
      );
    });

    const labels = this.modal.querySelectorAll(
      '.complete-the-look-modal__progress-label'
    );

    labels.forEach((label, index) => {
      const tier = index + 1;

      label.classList.toggle(
        'complete-the-look-modal__progress-label--marked',
        progressCount >= tier
      );
    });

    let progress = 0;

    if (progressCount >= 3) {
      progress = 100;
    } else if (progressCount === 2) {
      progress = 51.5;
    } else if (progressCount === 1) {
      progress = 18;
    }

    this.progressFill.style.width = `${progress}%`;

    if (progressCount >= 3) {
      this.progressText.innerHTML = this.tierMessages[3];
    } else if (progressCount === 2) {
      this.progressText.innerHTML = this.tierMessages[2];
    } else if (progressCount === 1) {
      this.progressText.innerHTML = this.tierMessages[1];
    } else {
      this.progressText.textContent =
        `Add an accessory to unlock ${this.discountTiers[1]}% off.`;
    }
  }

  getDiscountTier(accessoryCount, hasMainProduct = false) {
    if (!hasMainProduct) {
      return 0;
    }

    if (accessoryCount >= 2) {
      return this.discountTiers[3];
    }

    if (accessoryCount === 1) {
      return this.discountTiers[2];
    }

    return this.discountTiers[1];
  }

  getDiscountedPrice(priceCents) {
    return Math.round(
      priceCents * (1 - this.currentDiscount / 100)
    );
  }

  updateProductPricing() {
    this.productsContainer.querySelectorAll('.complete-the-look-card').forEach(card => {
      const priceCents = Number(card.dataset.price);
      const price = card.querySelector('.ctl-price');
      const badge = card.querySelector('.ctl-discount-badge');

      if (!price || !badge) return;

      if (this.currentDiscount > 0) {
        const discountedPrice =
          this.getDiscountedPrice(priceCents);

        price.innerHTML = `
          <span class="ctl-price-current">
            ${this.formatMoney(discountedPrice)}
          </span>
          <span class="ctl-price-original">
            ${card.dataset.formattedPrice}
          </span>
          
        `;

        badge.textContent = `${this.currentDiscount}% off`;
        badge.hidden = false;
      } else {
        price.innerHTML = `
          <span class="ctl-price-current">
            ${card.dataset.formattedPrice}
          </span>
        `;

        badge.hidden = true;
      }
    });
  }
    

  async loadProducts() {

    this.productsContainer.innerHTML = `
      ${this.renderSkeletons(3)}
    `;

    const recommendations = document.querySelector(
      'product-recommendations'
    );

    if (!recommendations) {
      console.warn('Recommendations element not found.');
      return;
    }

    const url = new URL(recommendations.dataset.url, window.location.origin);

    url.searchParams.set('limit', '10');

    const response = await fetch(url);
    console.log('recommendations', response)

    if (!response.ok) {
      throw new Error('Failed to fetch recommendations.');
    }

    const html = await response.text();

    const parser = new DOMParser();

    const doc = parser.parseFromString(html, 'text/html');
    console.log(doc);

    const cards = doc.querySelectorAll('.product-recommendations .grid__item.grid-product');
    console.log(
      'Complementary products returned:',
      [...cards].map(card => ({
        id: card.dataset.productId,
        title: card.querySelector('.grid-product__title')?.textContent.trim()
      }))
    );

    const filteredCards = [...cards].filter(card => card.dataset.productId !== this.productId.toString());
    console.log(
      'Products after filtering:',
      filteredCards.map(card => ({
        id: card.dataset.productId,
        title: card.querySelector('.grid-product__title')?.textContent.trim()
      }))
    );

    const products = [...cards].filter(card => card.dataset.productId !== this.productId.toString()).map((card) => {
    const image = card.querySelector('img');
    const title = card.querySelector('.grid-product__title');
    const price = card.querySelector('.grid-product__price');
    const button = card.querySelector('.btn-custom-upsell');
    const discountedPrice = this.getDiscountedPrice(Number(card.dataset.price));
    

      return {
        productId: card.dataset.productId,
        handle: card.dataset.productHandle,
        title: title?.textContent.trim(),
        price: Number(card.dataset.price),          
        formattedPrice: price?.textContent.trim(),
        discountedPrice,
        image: image?.src,
        variantId: button?.dataset.id,
        bundleDiscountEligible: card.dataset.bundleDiscountEligible === 'true',
        swatches: JSON.parse(card.dataset.productSwatches || '[]')
      };
    });
    
    this.eligibleVariantIds = new Set();
    products.forEach(product => {
      if (!product.bundleDiscountEligible) return;

      this.eligibleVariantIds.add(Number(product.variantId));

      product.swatches.forEach(swatch => {
        this.eligibleVariantIds.add(Number(swatch.variantId));
      });
    });

    this.productsContainer.innerHTML = products
      .map((product, index) => `
        <div class="complete-the-look-card"  data-product-index="${index}" data-price="${product.price}" data-formatted-price="${product.formattedPrice}">
          <a
            class="ctl-link"
            href="/products/${product.handle}">
            <img
              class="ctl-image"
              src="${product.image}"
              alt="${product.title}"
            >
          </a>

          <div class="ctl-content">
            <a
              class="ctl-link"
              href="/products/${product.handle}">

              <h3 class="ctl-title">
                ${product.title}
              </h3>

            </a>
            <div class="ctl-price">
              ${
                this.currentDiscount > 0
                  ? `
                    <span class="ctl-price-current">
                      ${this.formatMoney(
                        this.getDiscountedPrice(product.price)
                      )}
                    </span>
                    <span class="ctl-price-original">
                      ${product.formattedPrice}
                    </span>
                    
                  `
                  : `
                    <span class="ctl-price-current">
                      ${product.formattedPrice}
                    </span>
                  `
              }
            </div>

        

         

            <div class="grid-product__colors grid-product__colors-grid">
              ${product.swatches.map((swatch, swatchIndex) =>  `
                <button
                  type="button"
                  class="color-swatch color-swatch-pr-grid color-swatch--small ctl-swatch ${
                    swatch.handle === product.handle ? 'active' : ''
                  } ${
                    this.useColorSwatches ? 'native' : ''
                  }
                  ${
                    this.useColorSwatches ? swatch.colorSwatchHex ? '' : swatch.colorSwatchImage ? 'native-image' : '' : ''
                  }
                  ${
                    swatchIndex >= 8 ? 'ctl-swatch--hidden' : ''
                  }
                  "
                  style="
                      ${
                        this.useColorSwatches
                          ? swatch.colorSwatchHex
                            ? `--swatch-background: linear-gradient(
                                to right,
                                ${swatch.colorSwatchHex},
                                ${swatch.colorSwatchHex}
                              );`
                            : swatch.colorSwatchImage
                              ? `background-image: url(${swatch.colorSwatchImage});
                                background-size: cover;`
                              : `background-image: url(${swatch.swatchImage});
                                background-size: contain;`
                          : `background-image: url(${swatch.swatchImage});
                            background-size: contain;`
                      }
                    "
                  data-swatch='${JSON.stringify(swatch)}'>

                  <span class="sr-only">${swatch.title}</span>

                </button>
              `).join('')}

              ${
                product.swatches.length > 8
                  ? `
                    <button
                      type="button"
                      class="ctl-swatch-more"
                      aria-label="Show more colors"
                    >
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 14 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                    >
                      <path
                        d="M7 2V12M2 7H12"
                        stroke="currentColor"
                        stroke-width="1.25"
                        stroke-linecap="round"
                      />
                    </svg>
                    </button>
                  `
                  : ''
              }
            </div>
          
            <div class="ctl-footer">
              <span
                class="ctl-discount-badge"
                ${this.currentDiscount === 0 ? 'hidden' : ''}
              >
                ${this.currentDiscount}% off
              </span>

              <button
                class="complete-the-look-atc ctl-add"
                data-variant-id="${product.variantId}">
                 <span class="ctl-add-text">+ Add</span>
                  <span class="ctl-add-added" hidden>
                    <span class="ctl-add-check">
                      <svg xmlns="http://www.w3.org/2000/svg" width="11" height="8" viewBox="0 0 11 8" fill="none">
                        <path d="M1 4.375L3.625 7L9.625 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </span>
                    Added
                  </span>
                  <span class="ctl-add-spinner" hidden></span>
              </button>
            </div>
          </div>
        </div>
      `)
      .join('');

    this.productsContainer
      .querySelectorAll('.complete-the-look-atc')
      .forEach((button) => {
        button.addEventListener('click', (event) => {
          event.stopPropagation();
          event.preventDefault();
          this.addToCart(button.dataset.variantId, button);
        });
      });

    this.productsContainer.querySelectorAll('.ctl-swatch-more').forEach(button => {
      button.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();

        const container = button.closest(
          '.grid-product__colors'
        );

        container
          .querySelectorAll('.ctl-swatch--hidden')
          .forEach(swatch => {
            swatch.classList.remove('ctl-swatch--hidden');
          });

        button.remove();
      });
    });
    

    const count = await this.getEligibleAccessoryCount();

    document.querySelectorAll('.ctl-swatch').forEach(button => {
      button.addEventListener('click', () => {
        const card = button.closest('.complete-the-look-card');
        const swatch = JSON.parse(button.dataset.swatch);

        // Update the card's current product/variant data
        card.dataset.price = swatch.priceCents;
        card.dataset.formattedPrice = swatch.price;

        // Update product information
        card.querySelector('.ctl-image').src = swatch.image;
        card.querySelector('.ctl-title').textContent = swatch.title;
        card.querySelector('.ctl-add').dataset.variantId = swatch.variantId;
        card.querySelector('.ctl-link').href = swatch.url;

        // Update pricing based on the current discount tier
        this.updateProductPricing();
        this.updateProgress();

        // Update active swatch
        card
          .querySelectorAll('.ctl-swatch')
          .forEach(el => el.classList.remove('active'));

        button.classList.add('active');
        this.updateAddedButtons();
      });
    });

    requestAnimationFrame(() => {
      this.updateProductsOverflow();
    });
  }

  updateProductsOverflow() {
    if (
      !this.contentContainer ||
      !this.productsContainer ||
      !this.modalHeader ||
      !this.modalActions
    ) return;

    const contentHeight = this.contentContainer.clientHeight;

    const headerHeight = this.modalHeader.offsetHeight;
    const actionsHeight = this.modalActions.offsetHeight;

    const contentStyles = window.getComputedStyle(
      this.contentContainer
    );

    const verticalPadding =
      parseFloat(contentStyles.paddingTop) +
      parseFloat(contentStyles.paddingBottom);

    const availableProductsHeight =
      contentHeight -
      headerHeight -
      actionsHeight -
      verticalPadding;

    const productsHeight = this.productsContainer.scrollHeight;

    const overflowAmount =
      productsHeight - availableProductsHeight;

    this.productsContainer.style.overflowY =
      overflowAmount >= 20 ? 'auto' : 'hidden';
  }

  async refreshBundleState() {
    const cartResponse = await this.getCart();

    this.cartVariantIds = new Set(
      cartResponse.items.map(item => Number(item.variant_id))
    );

    const response = await fetch(
      `${window.location.pathname}?section_id=${this.sectionId}`
    );

    if (!response.ok) {
      throw new Error('Failed to refresh bundle state.');
    }

    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const modal = doc.querySelector('#CompleteTheLookModal');

    if (!modal) return;

    this.eligibleAccessoryCount = Number(modal.dataset.eligibleAccessoryCount);
    const mainVariantId = Number(modal.dataset.mainVariantId);
    
    this.hasMainProduct = this.cartVariantIds.has(mainVariantId);

    this.currentDiscount = this.getDiscountTier(this.eligibleAccessoryCount, this.hasMainProduct);

    console.log('Bundle state:', {
      accessoryCount: this.eligibleAccessoryCount,
      discount: this.currentDiscount
    });
  }

  updateAddedButtons() {
    const buttons = this.productsContainer.querySelectorAll(
      '.complete-the-look-atc'
    );

    buttons.forEach(button => {
      const isAdded = this.cartVariantIds?.has(
        Number(button.dataset.variantId)
      );

      const text = button.querySelector('.ctl-add-text');
      const added = button.querySelector('.ctl-add-added');

      button.classList.toggle('is-added', isAdded);

      if (text) {
        text.hidden = isAdded;
      }

      if (added) {
        added.hidden = !isAdded;
      }
    });
  }

  async addMainProduct() {
    const cart = await this.getCart();

    const hasMainProduct = cart.items.some(item =>
      item.variant_id === this.mainVariantId
    );

    if (!hasMainProduct) {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: this.mainVariantId,
          quantity: 1
        })
      });
    }
  }
  async addToCart(variantId, button) {
    const text = button.querySelector('.ctl-add-text');
    const spinner = button.querySelector('.ctl-add-spinner');

    button.classList.add('is-loading');
    text.hidden = true;
    spinner.hidden = false;

    // const cart = await this.getCart();
    const items = [];
    // console.log('Main variant:', this.mainVariantId);
    console.log('Accessory variant:', Number(variantId));
    // const hasMainProduct = cart.items.some(item =>
    //   item.variant_id === this.mainVariantId
    // );
    // if (!hasMainProduct) {

    //   items.push({
    //     id: this.mainVariantId,
    //     quantity: 1
    //   });

    // }
    items.push({
      id: Number(variantId),
      quantity: 1
    });
    console.log('Items being added:', items);
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({items})
      });

      if (!response.ok) {
        throw new Error('Failed to add product.');
      }
      console.log('Added to cart');
      await this.refreshBundleState();
      this.updateProgress();
      this.updateProductPricing();
      this.updateAddedButtons();

      // button.classList.add('is-added');
      // button.innerHTML = `
      //   <span class="ctl-add-check">
      //   <svg xmlns="http://www.w3.org/2000/svg" width="11" height="8" viewBox="0 0 11 8" fill="none">
      //     <path d="M1 4.375L3.625 7L9.625 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      //   </svg>
      //   </span>
      //   Added
      // `;
    } catch (error) {
      console.error(error);
    } finally {

      button.classList.remove('is-loading');
      text.hidden = false;
      spinner.hidden = true;

    }
  }
  formatMoney(cents) {
    return `${new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    }).format(cents / 100)}`;
    }
  renderSkeletons(count = 3) {
    return Array.from({ length: count })
      .map(() => `
        <div class="complete-the-look-card complete-the-look-card--skeleton">

          <div class="ctl-skeleton ctl-skeleton-image"></div>

          <div class="ctl-content">

            <div class="ctl-skeleton ctl-skeleton-title"></div>

            <div class="ctl-skeleton ctl-skeleton-price"></div>

            <div class="ctl-skeleton-swatches">
              ${Array.from({ length: 5 })
                .map(() => `<span class="ctl-skeleton ctl-skeleton-swatch"></span>`)
                .join('')}
            </div>

            <div class="ctl-skeleton ctl-skeleton-button"></div>

          </div>

        </div>
      `)
      .join('');
  }

  async getEligibleAccessoryCount() {
    const cart = await this.getCart();

    return cart.items
      .filter(item => this.eligibleVariantIds.has(item.variant_id))
      .reduce((total, item) => total + item.quantity, 0);
  }

  async getCart() {

    const response = await fetch('/cart.js');

    if (!response.ok) {
      throw new Error('Failed to fetch cart.');
    }

    return response.json();

  }
  
  async checkComplementaryProducts() {
    const recommendations = document.querySelector('product-recommendations');

    if (!recommendations) return;

    const response = await fetch(recommendations.dataset.url);
    const html = await response.text();

    const doc = new DOMParser().parseFromString(html, 'text/html');
    const cards = doc.querySelectorAll('.grid__item.grid-product');
    const products = [...cards].filter(
      card => card.dataset.productId !== this.productId.toString()
    );

    if (products.length == 0) {
      this.trigger.style.display = 'none';
      return;
    }
    this.trigger.style.display = 'inline-block';
  }

}

document.addEventListener('DOMContentLoaded', () => {

  new CompleteTheLook();

});
